import { Typography } from "@material-ui/core";
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import XAPPButton from "../Button/XAPPButton";

const Countdown = ({ time, callback, className, texto, showButton = false }) => {

  let ATime = time;// * (document.location.host.includes("local.hexapp") ? 1000 : 1);
  const [countdown, setCountdown] = useState(ATime);
  const blocked = useSelector(({ ScreenLock }) => Boolean(ScreenLock.open));

  useEffect(() => {
    if (!blocked) {
      if (countdown > 0) {
        const interval = setInterval(() => {
          setCountdown(countdown - 1);
        }, 1000);

        return () => clearInterval(interval);
      }
      else {
        callback();
        setCountdown(ATime);
      }
    }
  }, [countdown, blocked]);

  return (
    <React.Fragment>
      {showButton &&
        <XAPPButton
          onClick={() => {
            callback();
            setCountdown(ATime);
          }}
          className={clsx(className, "text-24")}
          type="icon"
          icon="refresh"
        />
      }
      <Typography className={className}>{`${texto} ${countdown}s`}</Typography>
    </React.Fragment>
  )
};

export default Countdown;